@if (mapOptions) {
  <div>
    <google-map [options]="mapOptions" width="100%" [height]="height">
      <map-marker [position]="marker.position"></map-marker>
    </google-map>
  </div>
}
@if (label) {
  <div id="address-panel" [class.without-map]="!mapOptions">
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0767 5.0625C10.0767 7.85742 7.84396 10.125 5.09204 10.125C2.33908 10.125 0.107422 7.85742 0.107422 5.0625C0.107422 2.26652 2.33908 0 5.09204 0C7.84396 0 10.0767 2.26652 10.0767 5.0625ZM5.64588 2.25C5.64588 1.93922 5.39665 1.6875 5.09204 1.6875C3.22627 1.6875 1.76896 3.19852 1.76896 5.0625C1.76896 5.37187 2.01681 5.625 2.32281 5.625C2.62742 5.625 2.87665 5.37187 2.87665 5.0625C2.87665 3.82148 3.87011 2.8125 5.09204 2.8125C5.39665 2.8125 5.64588 2.56078 5.64588 2.25ZM3.98434 16.875V11.148C4.34434 11.2148 4.71473 11.2184 5.09204 11.2184C5.46934 11.2184 5.83973 11.2148 6.19973 11.148V16.875C6.19973 17.4973 5.70473 18 5.09204 18C4.47934 18 3.98434 17.4973 3.98434 16.875Z"
        fill="#B91C1C"
      />
    </svg>
    <p id="address-label">
      {{ address.street }}, {{ address.zipCode }} {{ address.city }}
    </p>
  </div>
}
